import * as React from 'react'
import I18n from '../../../../core/i18n'
import { agentService } from '../../../../core/services'
import { InputText } from '../../../atoms'
import AgentLayoutNew from '../_layouts/new'
import * as interfaces from '../../../../static/interfaces'

declare var window: interfaces.IWindow

const FIELDS = {
  name: 'name',
  position: 'position',
}

const title = I18n.t('admin.create_new', {
  model: I18n.t('skill', { scope: 'activerecord.models' }),
})

const AgentSkillsNew: React.FC<{}> = props => {
  const handleSubmit = React.useCallback(async (initialValues, values) => {
    const { createdSkills, flush } = await agentService.createSkills(values)
    window.flashMessages.addMessage({ text: flush.message, type: flush.type })
    location.href = '/agent/agent_skills'
  }, [])

  return (
    <AgentLayoutNew
      model="skills"
      title={title}
      fields={FIELDS}
      indexLink="/agent/agent_skills"
      formItems={
        <>
          <InputText required={true} name="name" defaultValue="" label={I18n.t('generic.name')} />
          <InputText
            required={true}
            name="position"
            defaultValue=""
            label={I18n.t('generic.position')}
          />
        </>
      }
      handleSubmit={handleSubmit}
    />
  )
}

export default AgentSkillsNew
